enum EnhancementFieldType {
  ORGANIZATION_DESCRIPTION = "ORGANIZATION_DESCRIPTION",
  TABLE_TALK_BIO = "TABLE_TALK_BIO",
  ACTIVITY_DESCRIPTION = "ACTIVITY_DESCRIPTION",
  PARTICIPANT_INSTRUCTIONS = "PARTICIPANT_INSTRUCTIONS",
  SCHEMA_FIELD = "SCHEMA_FIELD",
  PRODUCT_DESCRIPTION = "PRODUCT_DESCRIPTION"
}

export default EnhancementFieldType;
